import React from 'react';
import cn from 'classnames';
import { FileAccessType } from '../types';
import styles from './fileVisibility.module.scss';

interface IProps {
  value?: string,
  centered?: boolean,
  alignRight?: boolean,
}

const Visibility = ({ value, centered, alignRight }: IProps) => {
  if (!value) {
    return null;
  }

  const isPublic = value.toLowerCase() === FileAccessType.Public;

  return (
    <div className={
        cn(
          styles.wrapper,
          { [styles.public]: isPublic, [styles.centered]: centered, [styles.alignRight]: alignRight },
        )
      }
    >
      <span
        className={ styles.fileVisibility }
        data-test={ `visibilityType${ value }` }
      >
        { value }
      </span>
    </div>
  );
};

export default Visibility;
